import { render, staticRenderFns } from "./food-table-takeaway.vue?vue&type=template&id=d9c8285a&scoped=true&"
import script from "./food-table-takeaway.vue?vue&type=script&lang=js&"
export * from "./food-table-takeaway.vue?vue&type=script&lang=js&"
import style0 from "./food-table-takeaway.vue?vue&type=style&index=0&id=d9c8285a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d9c8285a",
  null
  
)

export default component.exports